<div class="main-content">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{ color }}">
				<h4 class="card-title mb-0">
					<i class="material-icons" (click)="back()" style="cursor: pointer;">arrow_left</i> Stock Counts
				</h4>
				<p class="card-category"></p>
			</div>
			<div class="card-body">
				<div class="container-fluid tp-box" [@flipState]="flip">
					<div class="tp-box__side tp-box__front" id="frontside" [ngClass]="flip != 'active' ? '' : 'd-none'">

						<!-- Filter Toggle Button - Always Visible -->
						<div class="row mb-3" *ngIf="sheetForm">
							<div class="col-12 d-flex justify-content-between align-items-center flex-wrap gap-2">
								<button *ngIf="filtersExpanded" type="button" mat-stroked-button color="warn" (click)="toggleFilters()" class="d-flex align-items-center">
									<mat-icon>expand_less</mat-icon>
									<span class="ms-1">Hide Filters</span>
								</button>
								<button *ngIf="!filtersExpanded" type="button" mat-raised-button color="warn" (click)="toggleFilters()" class="d-flex align-items-center">
									<mat-icon>expand_more</mat-icon>
									<span class="ms-1">Show Filters</span>
								</button>
							<button mat-raised-button color="warn" type="submit" form="stockCountForm" class="ms-auto">
								<mat-icon class="me-1">list</mat-icon>Load Items
							</button>
							</div>
						</div>

					<form [formGroup]="sheetForm" *ngIf="sheetForm" id="stockCountForm" class="no-overflow" (ngSubmit)="createLoadSheets()">

							<!-- Collapsible Filters -->
							<div [@slideInOut]="filtersExpanded ? 'in' : 'out'" class="filter-section">
								<div class="row g-3 mb-3">
									<div class="col-12 col-md-6 col-lg-3">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Warehouse</mat-label>
											<mat-select formControlName="location">
												<mat-option *ngFor="let loc of locations" [value]="loc.loccode">
													{{ loc.locationname }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-12 col-md-6 col-lg-3">
										<app-vendor-auto-complete [defaultIncludeInactive]="true" [showIncludeInactiveToggle]="false" (vendor_selected)="selectVendor($event)"></app-vendor-auto-complete>
									</div>
									<div class="col-12 col-md-6 col-lg-3">
										<app-category-autocomplete [supplier]="vendor_selected" (value_selected)="selectCategory($event)"></app-category-autocomplete>
									</div>
									<div class="col-12 col-md-6 col-lg-3">
										<app-productline-autocomplete [category]="category_selected" [supplier]="vendor_selected" (value_selected)="selectProductLine($event)"></app-productline-autocomplete>
									</div>
								</div>
								<div class="row g-3 mb-3">
									<div class="col-12 col-md-6">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Scan / Enter an Item</mat-label>
											<input matInput type="text" placeholder="Scan / Enter an Item" formControlName="stockid"/>
											<span matSuffix>
												<button tabindex="-1" mat-icon-button type="button" (click)="keywordItemSearch()">
													<mat-icon>search</mat-icon>
												</button>
												<button mat-icon-button type="button">
													<mat-icon>camera</mat-icon>
												</button>
											</span>
										</mat-form-field>
									</div>
									<div class="col-12 col-md-6">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Scan / Enter a Bin</mat-label>
											<input matInput type="text" placeholder="Scan / Enter a Bin" formControlName="keywords"/>
											<span matSuffix>
												<button tabindex="-1" mat-icon-button type="button" (click)="keywordSearch()">
													<mat-icon>search</mat-icon>
												</button>
												<button mat-icon-button type="button">
													<mat-icon>camera</mat-icon>
												</button>
											</span>
										</mat-form-field>
									</div>
								</div>
							</div>

							<div class="row g-3 mb-3">
								<div class="col-12 col-md-8">
									<div class="alert alert-light border mb-0" *ngIf="!counting_items"> 
										<strong class="d-block mb-2">How to Use Stock Counts:</strong>
										<ol class="mb-2 ps-3">
											<li>Select a <strong>Warehouse</strong> (required)</li>
											<li>Optionally filter by Vendor, Category, Product Line, Item, or Bin</li>
											<li>Click <strong>"Load Items"</strong> to load items for counting (will load existing counts if available)</li>
											<li>Enter actual quantities in the <strong>"QUANTITY ACTUAL"</strong> column</li>
											<li>Counts are saved automatically as you type</li>
											<li>Click <strong>"Review"</strong> to view adjustments and close counts</li>
										</ol>
										<small class="text-muted d-block mt-2">
											<i class="fa fa-lightbulb-o me-1"></i><strong>Tip:</strong> Use the "Count Sheets PDF" button to print count sheets for physical counting
										</small>
									</div>
								</div>
								<div class="col-12 col-md-4 text-md-end text-center" *ngIf="!counting_items">
									<span *ngIf="sending">
										<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
											<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
										</svg>
									</span>
								</div>
							</div>
						</form>

						<div class="text-center mb-3" *ngIf="fetching">
							<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
							</svg>
						</div>
						<div class="col-12 mb-3" [ngClass]="{'d-none': !counting_items}">
							<div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
								<mat-paginator #paginatorTop [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator>
								<div class="d-flex align-items-center gap-2">
									<small class="text-muted" *ngIf="autoSaving">
										<i class="fa fa-spinner fa-spin pr-1"></i> Auto-saving...
									</small>
									<small class="text-success" *ngIf="!autoSaving && lastAutoSaveSuccess && counting_items && counting_items.data && counting_items.data.length > 0">
										<i class="fa fa-check-circle pr-1 me-1"></i>Saved
									</small>
								</div>
							</div>
						</div>
						<div #count_table class="table mt-3" *ngIf="counting_items">
							
							<table class="table table-bordered table-hover pure-table pure-table-bordered" >
								<thead>
									<tr>
										<!-- <td>here</td> -->
										<td class="text-center">LINE</td>
										<td class="text-center">BIN</td>
										<td class="text-center">ITEM /<br>(MFG) </td>
										<td class="text-center">DESCRIPTION /<br>(BARCODE)</td>
										<td class="text-center">QUANTITY ON HAND</td>
										<td class="noprint text-center">QUANTITY<br> ACTUAL</td>
										<td class="noshow text-center">QUANTITY<br> ACTUAL</td>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let item of dataObs | async ;trackBy: identify ">
										<tr [ngClass]="getRowClass(item)">
											<td class="text-center"> {{ item.line }}</td>
											<td class="text-center"> {{ item.bin }}</td>
											<td class="text-center"> {{ item.partno }}<br>{{ item.vendor }}</td>
											<td class="text-center"> {{ item.description }}<br>{{item.vendeopartno}}</td>
											<td class="text-center"> {{ item.qoh }}</td>
											<td class="text-center noprint">
												<!-- no NUMBER! leaves mouse scoll -->
												<input 
													class="form-control text-center" 
													[ngClass]="getInputBackgroundClass(item)" 
													type="text" 
													[value]="getCountedDisplayValue(item)" 
													pattern="[0-9]*" 
													inputmode="numeric" 
													(input)="setQty($event, item)">
											</td>
											<td class="text-center noshow">
												<span class="mt-3">_________</span>
											</td>
										</tr>
									</ng-container>
								</tbody>
							</table>
						</div>
					</div>
					<div class="tp-box__side tp-box__back" [ngClass]="flip != 'inactive' ? '' : 'd-none'">
						<ng-container>
							<app-review-counts
								#reviewComponent
								[filters]="sheetForm.value"
								(complete)="resetSheets($event)"
								*ngIf="sheetForm"
								[flip]="flip">
							</app-review-counts>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="col-12">
	<div id="floater-container">
	</div>
</div>
<nav class="navbar fixed-bottom navbar-dark bg-dark" id="bottom-nav">
	<div class="container-fluid">
			<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 w-100 pe-3">
			<!-- Left: Status & Export Actions -->
			<div class="d-flex align-items-center gap-2 flex-wrap">
				<!-- Auto-save Status -->
				<div class="d-flex align-items-center text-white" *ngIf="flip == 'inactive'">
					<span *ngIf="autoSaving" class="badge bg-info">
						<i class="fa fa-spinner fa-spin pr-1 me-1"></i>Auto-saving...
					</span>
					<span *ngIf="!autoSaving && lastAutoSaveSuccess && counting_items && counting_items.data && counting_items.data.length > 0" class="badge bg-success">
						<i class="fa fa-check-circle pr-1 me-1"></i>All changes saved
					</span>
					<span *ngIf="!autoSaving && !lastAutoSaveSuccess && counting_items && counting_items.data && counting_items.data.length > 0" class="badge bg-secondary">
						<i class="fa fa-circle pr-1 me-1"></i>Ready
					</span>
				</div>

				<!-- Export Buttons -->
				<div class="d-flex align-items-center gap-2" *ngIf="counting_items && counting_items.data && counting_items.data.length > 0 && flip == 'inactive'">
					<span class="text-white me-2 d-none d-md-inline">Export:</span>
					<a href="{{ pdfLink() }}" class="btn btn-outline-light btn-sm" title="Download PDF Count Sheets">
						<i class="fa fa-file-pdf-o pr-1 me-1"></i>Count Sheets PDF
					</a>
					<button type="button" class="btn btn-outline-light btn-sm" (click)="$event.preventDefault();exportXls()" [disabled]="exporting" title="Download Excel Count Sheets">
						<i class="fa fa-file-excel-o pr-1 me-1"></i>Count Sheets Excel
					</button>
					<span *ngIf="exporting" class="text-white ms-2">
						<svg class="spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</div>
			</div>

			<!-- Right: Primary Actions -->
			<div class="d-flex align-items-center gap-2">
				<!-- Reset Button - Far Left with padding to avoid left nav -->
				<button type="button" class="btn btn-danger reset-button-left" (click)="resetCounts()" [disabled]="!counting_items">
					<i class="fa fa-undo pr-1 me-1"></i>Reset
				</button>
				
				<!-- Close Button (only when reviewing) -->
				<button type="button" class="btn btn-dark" (click)="closeCounts()" *ngIf="flip == 'active' && reviewComponent && reviewComponent.items && !reviewComponent.count_results">
					<i class="fa fa-check-circle pr-1 me-1"></i>Close & Adjust Stock
				</button>

				<!-- Review / Back to Counting Button -->
				<button type="button" class="btn btn-outline-warning" (click)="toggleFlip()" [title]="flip == 'inactive' ? 'Switch to Review View' : 'Switch to Counting View'">
					<i class="fa fa-exchange pr-1 me-1"></i>
					<span *ngIf="flip == 'inactive'">Review</span>
					<span *ngIf="flip == 'active'">Back to Counting</span>
				</button>
			</div>
		</div>
	</div>
</nav>
